var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _extends from "@babel/runtime/helpers/extends";
import { ExpandLess, ExpandMore, MoreVert } from "@mui/icons-material";
import { Chip, Stack, useMediaQuery } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import dayjs from 'dayjs';
import { useNavigate } from "react-router-dom";
import { ListPagePhoneIcon } from "../../../assets/customIcons";
import ActionMenuList from "../../../builderPackage/components/actionsMenuList";
import { DynamicCatalogBuilder } from "../../../builderPackage/components/dynamicCatalogBuilder/dynamicCatalogBuilder";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import InfiniteScroll from "../../../builderPackage/components/infiniteScroll/infiniteScroll";
import useRbacController from "../../../builderPackage/rbac/useRbacController";
import NpsChip from "../../../components/molecules/NPSChip";
import NoDocumentFoundPage from "../../../components/templates/noDocumentsFoundPage";
import { EUserRole, JC_ALERT_TYPES, LOCAL_STORAGE_KEYS, StatusEnum } from "../../../constants";
import { showSurface } from "../../../redux/awaitedSurfacesSlice";
import { setState } from "../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { getStatusColor } from "../../../theme/statusColors";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import { getCTAList } from "../../../utils/utils";
import AssignFinalInspectorPopup from "../assignFinalInspectorPopup";
import { JobCardPaging } from "../services/JobCardApiCall";
import { getFeaturesByStatusAndRbac, JcKey, JCMenuFeatures, ListViewTypes } from "../services/jcEntity";
import ServiceEstimateDrawer from "./ServiceEstimateDrawer";
import NewCancelPopup from "./newJobCardCta/CancelCta";
import ReassignServiceAdvisor from "./newJobCardCta/ReassignServiceAdvisor";
import TaskSummaryJc from "./taskSummaryJc";
import { MuiStack } from "../../../components";
import { useEffect } from "react";
import { resetState } from "../../reports/chitraSlice";
var NewJobCardPaging = function (props) {
    var _getLocalStorageItem, _crud$JcKey$JcPaging, _crud$JcKey$JcPaging2, _value$BranchId, _value$Status, _value$RepairTypeId, _value$ProductId, _ref, _crud$JcKey$JcPaging$, _crud$JcKey$JcPaging3, _crud$JcKey$JcPaging4;
    var value = props.value;
    var dispatch = useAppDispatch();
    var navigate = useNavigate();
    var IS_MOBILE = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var crud = useAppSelector(function (state) { return state.crud; });
    var selectedDesignationStorage = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_DESIGNATION);
    var SELECTED_CHANNEL = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var userOrganizationID = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    // const JobCardFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.MENU_FEATURE)
    var hasMore = !crud[JcKey.JcPaging] || ((_crud$JcKey$JcPaging = crud[JcKey.JcPaging]) === null || _crud$JcKey$JcPaging === void 0 || (_crud$JcKey$JcPaging = _crud$JcKey$JcPaging.data) === null || _crud$JcKey$JcPaging === void 0 ? void 0 : _crud$JcKey$JcPaging.length) < ((_crud$JcKey$JcPaging2 = crud[JcKey.JcPaging]) === null || _crud$JcKey$JcPaging2 === void 0 ? void 0 : _crud$JcKey$JcPaging2.TotalCount);
    var serviceTypes = getLocalStorageItem(LOCAL_STORAGE_KEYS.SERVICE_TYPES);
    var storedAllMenuFeatures = getLocalStorageItem(LOCAL_STORAGE_KEYS.ASSIGNED_MENUS);
    var rbacControl = useRbacController('/jobCard');
    var JobCardFeatures = getCTAList(storedAllMenuFeatures, "JobCard");
    var drawerContainerProps = {
        anchor: "right",
        PaperProps: {
            sx: {
                width: {
                    xs: '90%',
                    sm: '400px'
                }
            }
        }
    };
    var pagingRequest = {
        // Branches: [value?.BranchId ?? userOrganizationID],
        OrganizationId: (_value$BranchId = value === null || value === void 0 ? void 0 : value.BranchId) !== null && _value$BranchId !== void 0 ? _value$BranchId : userOrganizationID,
        Status: value === null || value === void 0 || (_value$Status = value.Status) === null || _value$Status === void 0 ? void 0 : _value$Status.map(function (item) { return item.Key; }),
        FromDate: value === null || value === void 0 ? void 0 : value.FromDate,
        ToDate: value === null || value === void 0 ? void 0 : value.ToDate,
        RepairTypeId: (_value$RepairTypeId = value === null || value === void 0 ? void 0 : value.RepairTypeId) !== null && _value$RepairTypeId !== void 0 ? _value$RepairTypeId : undefined,
        ProductId: (_value$ProductId = value === null || value === void 0 ? void 0 : value.ProductId) !== null && _value$ProductId !== void 0 ? _value$ProductId : undefined,
        IdentityId: (_ref = (value === null || value === void 0 ? void 0 : value.IdentityId) === "all" ? value === null || value === void 0 ? void 0 : value.ServiceAdvisor : value === null || value === void 0 ? void 0 : value.IdentityId) !== null && _ref !== void 0 ? _ref : undefined,
        Type: (selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) == EUserRole.FloorSupervisor ? 'FS' : undefined
    };
    useEffect(function () {
        dispatch(resetState(["documentDetailsGetById"]));
        dispatch(setState({
            key: "documentDetailsGetById",
            value: {}
        }));
    }, []);
    var handleActionClick = function (row, featureName) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, res, onViewEstimateClick;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!featureName)
                        return [2 /*return*/];
                    _a = featureName;
                    switch (_a) {
                        case JCMenuFeatures.Cancel: return [3 /*break*/, 1];
                        case JCMenuFeatures.ViewSpareIssue: return [3 /*break*/, 3];
                        case JCMenuFeatures.ViewServiceEstimate: return [3 /*break*/, 4];
                        case JCMenuFeatures.ViewTaskSummary: return [3 /*break*/, 5];
                        case JCMenuFeatures.ReassignServiceAdvisor: return [3 /*break*/, 6];
                        case JCMenuFeatures.AssignFinalInspector: return [3 /*break*/, 7];
                        case JCMenuFeatures.ReassignFinalInspector: return [3 /*break*/, 9];
                    }
                    return [3 /*break*/, 11];
                case 1: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Dialog',
                        Component: NewCancelPopup,
                        componentProps: {
                            state: row.id
                        }
                        //containerProps: drawerContainerProps,
                    }))];
                case 2:
                    res = _b.sent();
                    if (res !== null && res !== void 0 && res.payload) {
                        navigate("/jobCard");
                    }
                    return [2 /*return*/];
                case 3:
                    {
                        navigate("/spareIssues/createSpareIssues/".concat(row === null || row === void 0 ? void 0 : row.JobCardId, "/").concat(row === null || row === void 0 ? void 0 : row.OrganizationId, "?mode = view"));
                        return [2 /*return*/];
                    }
                    _b.label = 4;
                case 4:
                    {
                        onViewEstimateClick = function (item) {
                            dispatch(setState({
                                key: "getModuleHeaderCount",
                                value: []
                            }));
                            dispatch(setState({
                                key: "documentDetailsGetById",
                                value: {}
                            }));
                            // onDrawerSEClick();
                            navigate("/serviceEstimate-details/".concat(row === null || row === void 0 ? void 0 : row.ParentId));
                        };
                        dispatch(showSurface({
                            type: "Drawer",
                            Component: ServiceEstimateDrawer,
                            componentProps: {
                                estimateId: row === null || row === void 0 ? void 0 : row.ParentId,
                                jobCardId: row === null || row === void 0 ? void 0 : row.JobCardId,
                                onViewClick: onViewEstimateClick
                                // onCrossClick: () => { onClose() }
                            },
                            containerProps: drawerContainerProps
                        }));
                        return [2 /*return*/];
                    }
                    _b.label = 5;
                case 5:
                    {
                        dispatch(showSurface({
                            type: "Drawer",
                            Component: TaskSummaryJc,
                            componentProps: {
                                jobCardData: row,
                                id: row === null || row === void 0 ? void 0 : row.JobCardId
                            },
                            containerProps: drawerContainerProps
                        }));
                        return [2 /*return*/];
                    }
                    _b.label = 6;
                case 6:
                    {
                        dispatch(showSurface({
                            type: 'Dialog',
                            Component: ReassignServiceAdvisor,
                            componentProps: {
                                state: row
                            },
                            containerProps: {
                                maxWidth: 'xs'
                            }
                        }));
                        return [2 /*return*/];
                    }
                    _b.label = 7;
                case 7: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Dialog',
                        Component: AssignFinalInspectorPopup,
                        componentProps: {
                            isOpen: true,
                            data: row === null || row === void 0 ? void 0 : row.JobCardNo,
                            jobCardData: row,
                            assignValue: featureName
                        },
                        containerProps: drawerContainerProps
                    }))];
                case 8:
                    _b.sent();
                    return [2 /*return*/];
                case 9: return [4 /*yield*/, dispatch(showSurface({
                        type: 'Dialog',
                        Component: AssignFinalInspectorPopup,
                        componentProps: {
                            isOpen: true,
                            data: row === null || row === void 0 ? void 0 : row.JobCardNo,
                            jobCardData: row,
                            assignValue: featureName
                        },
                        containerProps: drawerContainerProps
                    }))];
                case 10:
                    _b.sent();
                    return [2 /*return*/];
                case 11: return [2 /*return*/];
            }
        });
    }); };
    var handleRowClick = function (e, row) {
        if (e.altKey || e.shiftKey)
            return;
        var path = "/jobcard-details/".concat(row === null || row === void 0 ? void 0 : row.id);
        if (e.ctrlKey || e.metaKey) {
            window.open(path, '_blank', 'noopener,noreferrer');
            return;
        }
        navigate(path);
    };
    var NPSColumn = {
        field: "NPSResponse",
        headerName: "NPS",
        align: 'center',
        minWidth: 120,
        renderCell: function (_ref2) {
            var _value$;
            var value = _ref2.value;
            if (!(value !== null && value !== void 0 && value.length)) {
                return '-';
            }
            var rating = (_value$ = value[0]) === null || _value$ === void 0 ? void 0 : _value$.AnswerRating;
            if (typeof rating !== 'number') {
                return '-';
            }
            return /*#__PURE__*/ React.createElement(NpsChip, {
                rating: rating
            });
        }
    };
    var pagingColumns = __spreadArray(__spreadArray([{
            type: 'string',
            field: "SourceDocumentNo",
            headerName: "Job card no",
            minWidth: 160
        }, {
            type: 'string',
            field: "CreatedOn",
            headerName: "Document Creation Date",
            valueFormatter: function (val) {
                if (!val || !dayjs(val).isValid())
                    return '-';
                return dayjs(val).format('DD MMM, YYYY hh:mm A');
            },
            minWidth: 180
        }, {
            field: "Customer",
            headerName: "Customer",
            flex: 1,
            minWidth: 200,
            valueFormatter: function (val, row) {
                var _row$Customer$GivenNa, _row$Customer, _row$Customer$FamilyN, _row$Customer2;
                return row !== null && row !== void 0 && row.Customer ? "".concat((_row$Customer$GivenNa = row === null || row === void 0 || (_row$Customer = row.Customer) === null || _row$Customer === void 0 ? void 0 : _row$Customer.GivenName) !== null && _row$Customer$GivenNa !== void 0 ? _row$Customer$GivenNa : '', " ").concat((_row$Customer$FamilyN = row === null || row === void 0 || (_row$Customer2 = row.Customer) === null || _row$Customer2 === void 0 ? void 0 : _row$Customer2.FamilyName) !== null && _row$Customer$FamilyN !== void 0 ? _row$Customer$FamilyN : '', " ") : '-';
            }
        }, {
            type: 'string',
            field: "RegistrationNo",
            headerName: "Registration no",
            minWidth: 200
        }], ((SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName) === "MC" ? [NPSColumn] : []), true), [{
            field: "MobileNumber",
            headerName: "Mobile number",
            minWidth: 150,
            valueFormatter: function (val, row) {
                var _row$Customer3;
                return row !== null && row !== void 0 && row.Customer ? "".concat(row === null || row === void 0 || (_row$Customer3 = row.Customer) === null || _row$Customer3 === void 0 ? void 0 : _row$Customer3.MobileNumber) : '-';
            }
        }, {
            field: "RepairTypeName",
            headerName: "Service type",
            flex: 2,
            minWidth: 150
        }, {
            field: "DeliveryDate",
            headerName: "Expt. delivery",
            flex: 1,
            minWidth: 150,
            valueFormatter: function (val) { return val ? dayjs(val).format('DD MMM, YYYY') : '-'; }
        }, {
            field: "ServiceAdvisorGivenName",
            headerName: "Service Advisor",
            flex: 1,
            minWidth: 150,
            valueFormatter: function (val, row) {
                var _row$ServiceAdvisorGi, _row$ServiceAdvisorFa;
                return ((_row$ServiceAdvisorGi = row === null || row === void 0 ? void 0 : row.ServiceAdvisorGivenName) !== null && _row$ServiceAdvisorGi !== void 0 ? _row$ServiceAdvisorGi : '') + ' ' + ((_row$ServiceAdvisorFa = row === null || row === void 0 ? void 0 : row.ServiceAdvisorFamilyName) !== null && _row$ServiceAdvisorFa !== void 0 ? _row$ServiceAdvisorFa : '');
            }
        }, {
            field: "Alerts",
            headerName: "Alerts",
            flex: 1,
            minWidth: 150,
            renderCell: function (params) {
                var _params$row;
                var alerts = params === null || params === void 0 || (_params$row = params.row) === null || _params$row === void 0 ? void 0 : _params$row.Alerts;
                if (!Array.isArray(alerts) || alerts.length === 0)
                    return null;
                return /*#__PURE__*/ React.createElement(MuiStack, {
                    direction: "row",
                    spacing: 2,
                    flexWrap: "wrap",
                    paddingTop: '13px',
                    display: 'flex'
                }, alerts.map(function (item, index) { /*#__PURE__*/ return React.createElement(Chip, {
                    key: index,
                    label: item.AlertName === JC_ALERT_TYPES.Repeat ? "Revisited" : item.AlertName,
                    size: "small",
                    shape: "rounded",
                    variant: "filled",
                    id: "status",
                    title: item.AlertName === JC_ALERT_TYPES.Repeat ? "Revisited" : item.AlertName,
                    color: "warning"
                }); }));
            }
        }, {
            field: "StatusName",
            headerName: "Status",
            flex: 1,
            minWidth: 150,
            renderCell: function (params) { return params !== null && params !== void 0 && params.value ? /*#__PURE__*/ React.createElement(Chip, _extends({
                label: params === null || params === void 0 ? void 0 : params.value,
                size: "small",
                shape: "rounded",
                id: 'status'
            }, getStatusColor((params === null || params === void 0 ? void 0 : params.value) || ''), {
                variant: "filled",
                "title": params.value
            })) : null; }
        }, {
            type: 'actions',
            field: 'actions',
            flex: 0.25,
            getActions: function (params) {
                var _params$row2;
                var res = getFeaturesByStatusAndRbac(params.row, rbacControl, serviceTypes, JobCardFeatures, selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name) || [];
                if ([StatusEnum.Cancelled, StatusEnum.Awaiting].includes((_params$row2 = params.row) === null || _params$row2 === void 0 ? void 0 : _params$row2.Key))
                    return [];
                return res === null || res === void 0 ? void 0 : res.map(function (menu) { /*#__PURE__*/ return React.createElement(GridActionsCellItem, {
                    label: menu.DisplayName
                    // icon={getIcon(data?.Name)}
                    ,
                    showInMenu: true,
                    onClick: function () {
                        handleActionClick(params.row, menu === null || menu === void 0 ? void 0 : menu.Name);
                    }
                }); });
            }
        }], false);
    var formData = [{
            type: FormItemTypes.CardComponent,
            name: 'card-element',
            columnSize: 12,
            contentProps: {
                spacing: 0.5
            },
            sx: {
                cursor: 'pointer'
            },
            setFieldProps: function (row) { return ({
                id: row === null || row === void 0 ? void 0 : row.id,
                onClick: function (e) {
                    e.stopPropagation();
                    e.preventDefault();
                    handleRowClick(e, row);
                }
            }); },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    justifyContent: "space-between",
                    display: "flex",
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 0,
                            justifyContent: 'center',
                            alignItems: 'flex-start',
                            flexDirection: 'column',
                            spacing: 0,
                            width: '44%',
                            elements: [{
                                    type: FormItemTypes.Typography,
                                    name: "RegistrationNo",
                                    columnSize: true,
                                    fontWeight: 'medium',
                                    value: '-',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    maxWidth: '100%'
                                }, {
                                    type: FormItemTypes.Typography,
                                    name: "ProductName",
                                    columnSize: true,
                                    fontSize: 'sm',
                                    fontWeight: 'normal',
                                    color: 'secondary.500',
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    display: 'block',
                                    maxWidth: '100%'
                                }]
                        }, {
                            type: FormItemTypes.ContainerItem,
                            name: '',
                            columnSize: 0,
                            spacing: 0,
                            columnGap: 1,
                            justifyContent: 'flex-end',
                            width: '56%',
                            elements: [{
                                    type: FormItemTypes.Chip,
                                    name: 'StatusName',
                                    size: 'small',
                                    columnSize: 0,
                                    shape: 'rounded',
                                    setFieldProps: function (state) { return ({
                                        type: FormItemTypes.Chip,
                                        color: getStatusColor(state === null || state === void 0 ? void 0 : state.StatusName).color,
                                        variant: 'filled'
                                    }); }
                                }, {
                                    type: FormItemTypes.IconButton,
                                    name: "menuIcon",
                                    color: 'secondary',
                                    size: 'small',
                                    children: /*#__PURE__*/ React.createElement(MoreVert, {
                                        color: "secondary",
                                        sx: {
                                            height: 18,
                                            width: 18
                                        }
                                    }),
                                    columnSize: 0,
                                    sx: {
                                        p: 0.5
                                    },
                                    setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                                        var res, action;
                                        return __generator(this, function (_a) {
                                            switch (_a.label) {
                                                case 0:
                                                    res = getFeaturesByStatusAndRbac(state, rbacControl, serviceTypes, JobCardFeatures, selectedDesignationStorage === null || selectedDesignationStorage === void 0 ? void 0 : selectedDesignationStorage.Name);
                                                    return [4 /*yield*/, dispatch(showSurface({
                                                            type: 'Menu',
                                                            containerProps: {
                                                                anchorEl: e.target.parentElement,
                                                                slotProps: {
                                                                    paper: {
                                                                        sx: {
                                                                            px: 0.5
                                                                        }
                                                                    }
                                                                }
                                                            },
                                                            Component: ActionMenuList,
                                                            componentProps: {
                                                                items: res === null || res === void 0 ? void 0 : res.map(function (data) {
                                                                    return {
                                                                        id: data === null || data === void 0 ? void 0 : data.Name,
                                                                        children: data === null || data === void 0 ? void 0 : data.DisplayName
                                                                    };
                                                                })
                                                            }
                                                        }))];
                                                case 1:
                                                    action = _a.sent();
                                                    handleActionClick(state, action.payload);
                                                    return [2 /*return*/];
                                            }
                                        });
                                    }); },
                                    setFieldProps: function (formValues) {
                                        return {
                                            hidden: [StatusEnum.Cancelled, StatusEnum.Awaiting].includes(formValues === null || formValues === void 0 ? void 0 : formValues.Key)
                                        };
                                    },
                                    onClick: function (e) {
                                        e.stopPropagation();
                                    }
                                }]
                        }]
                }, {
                    type: FormItemTypes.Accordian,
                    name: 'expanded',
                    value: true,
                    summaryProps: {
                        sx: {
                            display: 'none'
                        }
                    },
                    detailPanelProps: {
                        spacing: 1,
                        p: 1.5,
                        rowSpacing: 0
                    },
                    sx: {
                        bgcolor: 'background.secondary',
                        border: 'none'
                    },
                    columnSize: 12,
                    setFieldProps: function (row, expanded, field) {
                        return {
                            containerProps: {
                                my: expanded ? 1.5 : 0
                            },
                            onClick: function (e) {
                                e.stopPropagation();
                                e.preventDefault();
                                handleRowClick(e, row);
                            }
                        };
                    },
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: 'CustomerName',
                            label: 'Customer name: ',
                            fontWeight: 'medium',
                            component: 'a',
                            color: 'primary',
                            columnSize: 12,
                            align: 'right',
                            labelTypographyProps: {
                                mb: 0,
                                noWrap: true
                            },
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            columnGap: 0.5,
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            },
                            valueGetter: function (formValues) {
                                var _formValues$Customer$, _formValues$Customer, _formValues$Customer$2, _formValues$Customer2;
                                var currValue = ((_formValues$Customer$ = formValues === null || formValues === void 0 || (_formValues$Customer = formValues.Customer) === null || _formValues$Customer === void 0 ? void 0 : _formValues$Customer.GivenName) !== null && _formValues$Customer$ !== void 0 ? _formValues$Customer$ : '') + ' ' + ((_formValues$Customer$2 = formValues === null || formValues === void 0 || (_formValues$Customer2 = formValues.Customer) === null || _formValues$Customer2 === void 0 ? void 0 : _formValues$Customer2.FamilyName) !== null && _formValues$Customer$2 !== void 0 ? _formValues$Customer$2 : '');
                                if (currValue.trim())
                                    return currValue;
                                else
                                    return '-';
                            },
                            setFieldProps: function (state, val) {
                                var _state$Customer;
                                return {
                                    children: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ListPagePhoneIcon, {
                                        id: "mobile-no",
                                        color: "primary"
                                    }), val),
                                    href: "tel:".concat(state === null || state === void 0 || (_state$Customer = state.Customer) === null || _state$Customer === void 0 ? void 0 : _state$Customer.MobileNumber)
                                };
                            },
                            onClick: function (e) {
                                e.stopPropagation();
                            }
                        }, (SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName) === "MC" ? {
                            type: FormItemTypes.Typography,
                            name: 'NPSResponse',
                            label: 'NPS: ',
                            id: "customer-nps-rating",
                            columnSize: 12,
                            labelTypographyProps: {
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            },
                            setFieldProps: function (formValues, value) {
                                var _value$2;
                                var rating = value === null || value === void 0 || (_value$2 = value[0]) === null || _value$2 === void 0 ? void 0 : _value$2.AnswerRating;
                                if (typeof rating !== 'number') {
                                    return {
                                        children: '-'
                                    };
                                }
                                return {
                                    children: /*#__PURE__*/ React.createElement(NpsChip, {
                                        rating: rating
                                    })
                                };
                            }
                        } : null, {
                            type: FormItemTypes.Typography,
                            name: 'DeliveryDate',
                            label: 'Expt. delivery date & time:',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            columnSize: 12,
                            labelTypographyProps: {
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            },
                            valueGetter: function (formValues, field) {
                                var currValue = formValues !== null && formValues !== void 0 && formValues.DeliveryDate ? dayjs(formValues === null || formValues === void 0 ? void 0 : formValues.DeliveryDate).format('DD MMM, YYYY - h:mm A') : '-';
                                return currValue;
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'RepairTypeName',
                            label: 'Service type: ',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            columnSize: 12,
                            labelTypographyProps: {
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            },
                            valueGetter: function (formValues, field) {
                                var currValue = formValues === null || formValues === void 0 ? void 0 : formValues.RepairTypeName;
                                if (currValue)
                                    return currValue;
                                else
                                    return '-';
                            }
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'ServiceAdvisorGivenName',
                            label: 'Service Advisor: ',
                            fontSize: 'sm',
                            fontWeight: 'medium',
                            columnSize: 12,
                            labelTypographyProps: {
                                mb: 0
                            },
                            containerProps: {
                                display: 'flex',
                                direction: 'row',
                                justifyContent: 'space-between'
                            },
                            valueGetter: function (formValues, field) {
                                var _formValues$ServiceAd, _formValues$ServiceAd2;
                                var currValue = ((_formValues$ServiceAd = formValues === null || formValues === void 0 ? void 0 : formValues.ServiceAdvisorGivenName) !== null && _formValues$ServiceAd !== void 0 ? _formValues$ServiceAd : '') + " " + ((_formValues$ServiceAd2 = formValues === null || formValues === void 0 ? void 0 : formValues.ServiceAdvisorFamilyName) !== null && _formValues$ServiceAd2 !== void 0 ? _formValues$ServiceAd2 : '');
                                if (currValue.trim())
                                    return currValue;
                                else
                                    return '-';
                            }
                        }]
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    spacing: 0,
                    // justifyContent: "space-between",
                    elements: [{
                            type: FormItemTypes.Iterator,
                            name: 'Alerts',
                            columnSize: true,
                            value: null,
                            containerProps: {
                                container: true,
                                columnGap: 1
                            },
                            gridItemProps: {
                                xs: 0
                            },
                            elements: [{
                                    type: FormItemTypes.Chip,
                                    name: 'AlertName',
                                    columnSize: 0,
                                    color: 'warning',
                                    size: 'small',
                                    shape: "rounded",
                                    valueGetter: function (val, row) {
                                        return (val === null || val === void 0 ? void 0 : val.AlertName) === JC_ALERT_TYPES.Repeat ? "Revisited" : val === null || val === void 0 ? void 0 : val.AlertName;
                                    }
                                }]
                        }, {
                            type: FormItemTypes.Button,
                            name: 'expand-button',
                            columnSize: 0,
                            color: 'secondary',
                            size: 'small',
                            disableRipple: true,
                            disableFocusRipple: true,
                            sx: {
                                py: 0,
                                px: 0.5,
                                fontSize: 'sm'
                            },
                            setFormState: function (formValues, e) {
                                var _e$stopPropagation;
                                e === null || e === void 0 || (_e$stopPropagation = e.stopPropagation) === null || _e$stopPropagation === void 0 || _e$stopPropagation.call(e);
                                return {
                                    expanded: !(formValues !== null && formValues !== void 0 && formValues.expanded)
                                };
                            },
                            setFieldProps: function (formValues) {
                                return {
                                    type: this.type,
                                    children: formValues !== null && formValues !== void 0 && formValues.expanded ? ['Close', /*#__PURE__*/ React.createElement(ExpandLess, null)] : ['View more', /*#__PURE__*/ React.createElement(ExpandMore, null)]
                                };
                            },
                            onClick: function (e) {
                                e.stopPropagation();
                            }
                        }]
                }]
        }];
    if (!(value !== null && value !== void 0 && value.paging))
        return null;
    return /*#__PURE__*/ React.createElement(Stack, {
        px: {
            xs: 2,
            sm: 3
        },
        pt: 2,
        pb: {
            xs: 10,
            sm: 2
        }
    }, !IS_MOBILE && value.View !== ListViewTypes.Card ? /*#__PURE__*/ React.createElement(DynamicCatalogBuilder, {
        pagingAPIKey: JcKey.JcPaging,
        getPagingData: JobCardPaging,
        pagingAPIRequest: pagingRequest,
        columns: pagingColumns,
        dataGridProps: {
            disableColumnMenu: false,
            onRowClick: function (params, e) {
                handleRowClick(e, params.row);
            },
            initialState: {
                pinnedColumns: {
                    right: ['actions']
                }
            },
            rowCount: (_crud$JcKey$JcPaging$ = (_crud$JcKey$JcPaging3 = crud[JcKey.JcPaging]) === null || _crud$JcKey$JcPaging3 === void 0 ? void 0 : _crud$JcKey$JcPaging3.TotalCount) !== null && _crud$JcKey$JcPaging$ !== void 0 ? _crud$JcKey$JcPaging$ : 0
        }
    }) : /*#__PURE__*/ React.createElement(InfiniteScroll, {
        apiCall: JobCardPaging,
        apiKey: JcKey.JcPaging,
        apiRequest: pagingRequest,
        elements: formData,
        hasMore: hasMore,
        gridContainerProps: {
            spacing: 2
        },
        gridItemProps: {
            xs: 12,
            sm: 6,
            md: 4,
            lg: 4
        }
    }), (value.View == ListViewTypes.Card || IS_MOBILE) && ((_crud$JcKey$JcPaging4 = crud[JcKey.JcPaging]) === null || _crud$JcKey$JcPaging4 === void 0 ? void 0 : _crud$JcKey$JcPaging4.TotalCount) === 0 && /*#__PURE__*/ React.createElement(Stack, {
        pt: '50px',
        justifyContent: 'center'
    }, /*#__PURE__*/ React.createElement(NoDocumentFoundPage, {
        title: 'No job card found',
        paragraph: 'No job card created yet, Please create new job crad.'
    })));
};
export default NewJobCardPaging;
